import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "0b22cf5b1e4224f0ab8b93b0ab8ce8c506209a6b",
});
